import './App.css';
import LandingPage from './pages/LandingPage';
import Register from './pages/Register';
import LoginPage from './pages/LoginPage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ParentDashboard from './pages/ParentDashboard';
import StudentHome from './pages/StudentHome';
import QuizPage from './pages/QuizPage';
import DemoQuizPage from './pages/DemoQuizPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import LearningJourneyPage from './pages/LearningJourneyPage';
import LeaderboardPage from './pages/LeaderboardPage';
import { ToastContainer } from 'react-toastify';
import PasswordUpdatePage from './pages/PasswordUpdatePage';
import CurriculumPage from './pages/CurriculumPage';
import TrophyRoomPage from './pages/TrophyRoomPage';
import ProgressPage from './pages/ProgressPage';
import SchoolDashboard from './pages/SchoolDashboard';
import TermsOfServicePage from './pages/TermsOfServicePage';
import HelpCenterPage from './pages/HelpCenterPage';
import PricingPage from './pages/PricingPage';
import PrintablesPage from './pages/PrintablesPage';
import LeaderBoardPageNew from './pages/LeaderBoardPageNew';
import GoogleAnalyticsTracker from './components/GoogleAnalyticsTracker';
import Challenge20Page from './pages/Challenge20Page';
import { GoogleOAuthProvider } from '@react-oauth/google';

const ProtectedRoute = ({ children, allowedRole }) => {
  console.log('Active Google Client ID:', process.env.REACT_APP_GOOGLE_CLIENT_ID);
  const user = JSON.parse(localStorage.getItem('user'));

  if (!user) return <Navigate to="/login" />;
  if (user.role !== allowedRole) return <Navigate to="/" />;

  return children;
};

function App() {
  return (
    <div>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Router>
          <GoogleAnalyticsTracker />
          <Routes>
            {/* LANDING PAGE IS NOW THE ROOT */}
            <Route path="/" element={<LandingPage />} />

            {/* Other Routes */}
            <Route path="/parent-dashboard" element={<ParentDashboard />} />
            <Route path="/school-dashboard" element={<SchoolDashboard />} />
            <Route path="/parent/student/:id" element={<LearningJourneyPage />} />
            <Route path="/student/home" element={
              <ProtectedRoute allowedRole="student">
                <StudentHome />
              </ProtectedRoute>
            } />
            <Route path="/quiz/:topicId" element={<QuizPage />} />
            <Route path="/curriculum" element={<CurriculumPage />} />
            <Route path="/student/learning-journey" element={
              <ProtectedRoute allowedRole="student">
                <LearningJourneyPage />
              </ProtectedRoute>
            } />
            <Route path="/student/progress" element={
              <ProtectedRoute allowedRole="student">
                <ProgressPage />
              </ProtectedRoute>
            } />
            <Route path="/reset-password" element={<PasswordUpdatePage />} />
            <Route path="/trophy-room" element={<TrophyRoomPage />} />

            {/* Public Routes - No auth */}
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/try-demo" element={<DemoQuizPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/help-center" element={<HelpCenterPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/leaderboards" element={<LeaderBoardPageNew />} />
            <Route path="/printables" element={<PrintablesPage />} />
            <Route path="/challenge20k" element={<Challenge20Page />} />
          </Routes>
        </Router>
      </GoogleOAuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default App;
